import React from 'react';
import styled from 'styled-components';
import { cssSpacing, ButtonPrimary, createBasicColorSet, KeyboardDetectionProvider, } from '@spotify-internal/encore-web';
import { Grid, TWO_COLUMN_MAX_WIDTH } from '../../ui';
import { Media } from '../../ui/Components/Media';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
import { PageSectionHeader } from '../../ui/PageSectionHeader';
import { useFrodorModules } from '../../Context/FrodorModulesProvider';
const Header = styled(Grid) `
  padding-top: ${cssSpacing('looser-5')};
  padding-bottom: ${cssSpacing('looser-4')};

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-top: ${cssSpacing('looser-4')};
    padding-bottom: ${cssSpacing('looser-3')};
  }
`;
const MediaContainer = styled.div `
  grid-column: 8 / 13;
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
    order: 1;
  }
`;
const StyledPageSectionHeader = styled(PageSectionHeader) `
  display: flex;
  height: 100%;
  align-items: center;
  grid-column: 1 / 7;
  box-sizing: border-box;
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-top: ${cssSpacing('looser-2')};
    grid-column: 1 / -1;
    order: 2;
  }
`;
const TRACK_CAT = 'module-heroHeader';
export const HeaderModule = React.forwardRef(({ transparent, headline = '', subtext = '', supertext = '', tagline = '', isTagline = false, useLargeText = false, image, media, ctaLink = '', ctaText = '', colors, }, ref) => {
    const { InteractiveElement } = useFrodorModules();
    const formattedColors = {
        backgroundColor: colors === null || colors === void 0 ? void 0 : colors.backgroundColor,
        textColor: colors === null || colors === void 0 ? void 0 : colors.textColor,
    };
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: formattedColors, transparent: transparent },
            React.createElement(Header, { ref: ref },
                React.createElement(StyledPageSectionHeader, { columns: 6, headline: headline, eyebrow: supertext, paragraph: subtext, useLargeText: useLargeText, isTagline: isTagline, tagline: tagline, cta: ctaText && ctaLink ? (React.createElement(InteractiveElement, { customComponent: ButtonPrimary, href: ctaLink, trackingCategory: TRACK_CAT, trackingLabel: `CTA Link - ${ctaText}`, UNSAFE_colorSet: createBasicColorSet(formattedColors.textColor, formattedColors.backgroundColor) }, ctaText)) : undefined }),
                React.createElement(MediaContainer, null,
                    React.createElement(Media, { media: media, image: image }))))));
});
